<template>
  <div class="app-container">
    <!--查询条件-->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="95px" size="mini" style="width: 100%;">
        <div class="formItemBox">
          <el-form-item label="查询日期:" style="margin-top:7px;">
            <el-date-picker v-model="searchFrom.stockDate" placeholder="选择日期" type="date" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="查询时间:" style="margin-top:7px;">
            <el-date-picker v-model="searchFrom.stockDateHour" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </div>
        <div class="searchBtnBox" style="margin: 4px;">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="00ZP00BB001" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="00ZP00BB002" v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportClick" btnCode="00ZP00BB003" v-if="btnFlg[2]">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格  v-loading='tabLoading' -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="tableRef" border bordersize="mini" height="100%" style="width: 100%; margin-top: 10px" center @row-click="handleRowClick" @current-change="handleTabCurrentChange" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" :header-row-style="{ height: '45px' }" :row-style="{ height: '35px' }" highlight-current-row>
        <!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" align="center" min-width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allInWeight" label="" align="center" width="150">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="总入库吨数=当天入库卷板总吨数+当天入库建材总吨数。统计时间当天0:00-24:00" placement="top-start">
              <div>总入库吨数<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
            <div>{{scope.row.allInWeight}}</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allConfirmWeight" label="" align="center" width="180">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="待货主确认吨数=实时进仓待确认卷板吨数合计+实时进仓待确认建材吨数合计" placement="top-start">
              <div>待货主确认吨数<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
            <div>{{scope.row.allConfirmWeight}}</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allOutWeight" label="" align="center" width="150">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="总出库吨数=当天出库卷板总吨数+当天出库建材总吨数。统计时间当天0:00-24:00" placement="top-start">
              <div>总出库吨数<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
            <div>{{scope.row.allOutWeight}}</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allstockWeightBill" label="" align="center" min-width="180">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="开单未提吨数=未完成提单未提量+未完成手动出库计划量" placement="top-start">
              <div>开单未提吨数<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
            <div>{{scope.row.allstockWeightBill}}</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allstockWeight" label="" align="center" min-width="150">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="总库存=实时卷板库存+卷板进仓计划+实时建材仓位库存" placement="top-start">
              <div>总库存吨数<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
            <div>{{scope.row.allstockWeight}}</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allstockWeightJf" label="" align="center" min-width="150">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="建发库存=卷板货主为建发的库存量合计+建材类进仓待确认一级货主为建发的库存量合计+建材类客户库存中一级货主为建发的库存量合计+货主为建发的卷板进仓计划" placement="top-start">
              <div>建发库存吨数<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
            <div>{{scope.row.allstockWeightJf}}</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allstockWeightNotJf" label="" align="center" min-width="150">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="社会库存=卷板货主为非建发的库存量合计+建材类进仓待确认一级货主为非建发的库存量合计+建材类客户库存中一级货主为非建发的库存量合计+货主为非建发的卷板进仓计划" placement="top-start">
              <div>社会库存吨数<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
            <div>{{scope.row.allstockWeightNotJf}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {
  getWarehouseSummaryList // 列表
} from '@/api/wms-stock.js'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateFormat1 } from '@/utils/util'

export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00ZP00BB001',
        '00ZP00BB002',
        '00ZP00BB003'
      ],
      h: '570px',
      total: 0,
      searchFrom: {
        stockDate: dateFormat1(new Date().getTime())
      },
      tableList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/WarehouseSummary')
    this.getSeatchData()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.searchClick()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 查询接口
    getSeatchData () {
      getWarehouseSummaryList(this.searchFrom)
        .then((res) => {
          this.tableList = res
        })
        .catch((err) => {
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData()
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        stockDate: dateFormat1(new Date().getTime())
      }
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportWarehouseSummaryList',
        this.searchFrom,
        '仓库汇总表'
      )
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
/deep/.inpBox .el-input__inner {
  width: 170px;
}
.searchBox {
  margin-left: 25px;
}
.inpBox {
  margin: 5px 0 0 -30px;
}
.searchBtnBox {
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.tongJi {
  display: flex;
  margin-left: 10px;
}
.tongJi_item {
  margin-right: 20px;
}
.tongJi_item span {
  color: red;
}
.addstyle {
  margin-left: 94%;
}
/deep/.inpBox .el-date-editor .el-input__inner {
  width: 174px;
}
</style>
